import { useInject } from 'dependable-react';
import { css } from 'emotion';
import React, { useContext } from 'react';

import { TRANSLATIONS_SERVICE_TOKEN } from '../../services/InjectTokens';
import { BookContext } from '../Book';
import { Barcodes } from './components/Barcodes';
import { Images } from './components/Images';
import { Text } from './components/Text';
import { Avatars } from './components/Avatars';

import emptyPageHorizontal from '../../assets/empty-page-horizontal.png';
import emptyPageVertical from '../../assets/empty-page-vertical.png';

const pageContentStyle = css`
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
  overflow: hidden;
`;

const pageBackgroundStyle = css`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
`;

interface IProps {
  page: number;
  isCoverFront: boolean;
  isCoverBack: boolean;
  backgroundImage: string;
}

export const PageContent = ({ page, backgroundImage, isCoverFront, isCoverBack, ...rest }: IProps) => {
  const translations = useInject(TRANSLATIONS_SERVICE_TOKEN);
  const ctx = useContext<any>(BookContext);

  return (
    <div className={pageContentStyle} {...rest}>
      {backgroundImage && <img src={backgroundImage} className={pageBackgroundStyle} alt="Background" />}
      {!backgroundImage && !ctx.isWideFormat && (
        <img src={emptyPageHorizontal} className={pageBackgroundStyle} alt="Empty page" />
      )}
      {!backgroundImage && ctx.isWideFormat && (
        <img src={emptyPageVertical} className={pageBackgroundStyle} alt="Empty page" />
      )}
      <Avatars avatars={ctx.pageAvatars(page)} />
      {translations.get(page, ctx.contentString, ctx.variables).map(({ text, configs, images, barcodes }: any, i) => {
        return (
          <React.Fragment key={`book-element-${i.toString()}`}>
            <Text text={text} configs={configs} />
            {Boolean(images.length) && <Images images={images} />}
            {Boolean(barcodes.length) && <Barcodes barcodes={barcodes} />}
          </React.Fragment>
        );
      })}
    </div>
  );
};
